import BusinessCharacteristicsModelBase from '../_generated/modelBases/business-characteristics-model-base';

export default class BusinessCharacteristicsModel extends BusinessCharacteristicsModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
